import React from "react"
import { useMemo } from "react";

import classes from "./ChristmasTouchBanner.module.scss"

export default function MinimalTouchCta({
  onTouch,
  index,
}) {
  const messages =
    useMemo(() => [
      { lang: "fa", dir: "rtl", text: "برای ثبت یک تجربه لذیذ" },
      { lang: "ar", dir: "rtl", text: "لمس الشاشة" },
      { lang: "en", dir: "ltr", text: "For a delicious experience" },
    ], []);

  const messages2 =
    useMemo(() => [
      { lang: "fa", dir: "rtl", text: "لمس کنید" },
      { lang: "ar", dir: "rtl", text: "لبدء تجربة لذيذة" },
      { lang: "en", dir: "ltr", text: "touch to start" },
    ], []);

  const current = messages[index];

  const current1 = messages2[index];

  return (
    <section className={classes["touch-cta-section"]}>
      <div
        onClick={onTouch}
        onPointerDown={onTouch}
        aria-label="Touch to start ordering"
        className={classes["cta-button"]}
      >
        {/* Ring + Dot */}
        <span
          className={classes["anim-ring"]}
        />

        <span className={classes["anim-dot"]} />

        {/* Text */}
        <div className={classes["btn-content"]}>
          <span
            dir={current.dir}
            lang={current.lang}
            className={classes["main-text"]}
            key={current.lang}
          >
            <span>
              {current.text}
            </span>

            <br />

            <span className={classes["sub-text"]}>
              {current1.text}
            </span>
          </span>
        </div>
      </div>
    </section>
  );
}
